import { Chip, OutlinedInput, Portal } from "@mui/material";
import { useMemo, useState } from "react";
import { RightSidebar } from "../../../../job-page-components/right-sidebar.component";
import { useRefContext } from "../../../../../../context/RefContext";
import {
	ArticleEntityType,
} from "../../../../../../../../lib/supabase/supabaseTypes";
import { TariffWithPricesViewType } from "@/dentlab/src/store/Catalogs";
import "./styles.css";
import { ArticleTypeEnum } from "@/lib/supabase/supabaseEnums";
import { ItemListing } from "./item-listing.component";
import { articleTypeOptions } from "@/dentlab/src/lib/constants/options";
import { useJobStore } from "@/dentlab/src/store/Jobs";
import { JobDocumentTypeEnum } from "../../../job-document.types";
import { showNotification } from "@/dentlab/src/store/Central/selectors";

/**
 * JobItemsArticlesSelection
 */
export const JobItemsArticlesSelection: React.FC<{
	rows: ArticleEntityType[];
	label: string;
	jobItemCodes: { code_e: string }[];
	onAddArticleById: (code_e: string, id: number, options?: { force: boolean }) => void;
	jobDocumentId: number;
	isNewStyle: boolean;
}> = ({ rows, label, onAddArticleById, jobItemCodes, jobDocumentId, isNewStyle }) => {
	const { container } = useRefContext();
	const [selectedCategory, setSelectedCategory] = useState<ArticleTypeEnum>(
		ArticleTypeEnum.MATERIAL
	);
	const [searchTerm, setSearchTerm] = useState("");

	const { openedSidebar, closeSidebar } = useJobStore((state) => ({
		openedSidebar: state.openedSidebar,
		closeSidebar: state.closeSidebar,
	}));

	const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearchTerm(e.target.value);
	};

	const open =
		openedSidebar?.type === "article" &&
		openedSidebar?.documentId === jobDocumentId;

	const handleClose = () => {
		closeSidebar();
	};

	const handleSelect = (
		articleId: number | null,
		code_e: string,
		options?: { force: boolean }
	) => {
		if (!articleId) {
			showNotification({
				message: "Artikelcode fehlt",
				type: "error",
			});
			return;
		}
		onAddArticleById(code_e, articleId, options);
	};

	const handleClick = (
		e: React.MouseEvent<HTMLDivElement>,
		row: ArticleEntityType | TariffWithPricesViewType
	) => {
		const article = row as ArticleEntityType;
		if (e.ctrlKey || e.metaKey) {
			handleSelect(article.id, article.code_e, { force: true });
			return;
		}
		handleSelect(article.id, article.code_e);
	};

	const handleSelectCategory = (categoryValue: ArticleTypeEnum) => {
		setSelectedCategory(categoryValue);
	};
	const { jobDocument } = useJobStore((state) => ({
		jobDocument: state.jobDocuments[jobDocumentId],
	}));

	const visibleRows = useMemo(() => rows.filter((row) => {
		if (
			jobDocument?.type === JobDocumentTypeEnum.Tracing &&
			row.type !== ArticleTypeEnum.MATERIAL
		) {
			return false;
		}

		if (searchTerm) {
			return row.description_de?.match(new RegExp(searchTerm, "i")) || row.code_e?.match(new RegExp(searchTerm, "i"));
		} else {
			return selectedCategory === row.type;
		}
	}), [rows, jobDocument, searchTerm, selectedCategory]);

	return (
		<>
			{open && (
				<Portal container={container.current}>
					<RightSidebar
						title={label}
						onClose={handleClose}
						isNewStyle={isNewStyle}
					>
						<div
							style={{
								paddingTop: "10px",
								paddingBottom: "10px",
							}}
						>
							<div
								style={{
									display: "flex",
									flexWrap: "wrap",
									gap: "5px",
									margin: "0px 10px 10px 10px",
								}}
							>
								{articleTypeOptions.map((category) => {
									if (
										jobDocument?.type ===
											JobDocumentTypeEnum.Tracing &&
										category.value !==
											ArticleTypeEnum.MATERIAL
									) {
										return;
									}
									return (
										<Chip
											label={category.label}
											key={category.value}
											color="primary"
											size="small"
											variant={
												selectedCategory ===
												category.value
													? "filled"
													: "outlined"
											}
											onClick={() =>
												handleSelectCategory(
													category.value
												)
											}
											style={{
												cursor: "pointer",
											}}
										/>
									);
								})}
								<OutlinedInput
									className="mx-2 h-6"
									type="text"
									style={{
										fontSize: "14px",
									}}
									value={searchTerm}
									onChange={handleSearch}
									placeholder="Suchen"
								/>
							</div>
							<ItemListing
								jobItemCodes={jobItemCodes}
								rows={visibleRows}
								handleClick={handleClick}
							/>
						</div>
					</RightSidebar>
				</Portal>
			)}
		</>
	);
};
